import { createFileRoute } from "@tanstack/react-router";
import CalculatorImpozitAuto from "@/pages/CalculatorImpozitAuto";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/calculator-impozit-auto/")({
  head: () => routeHead("/calculator-impozit-auto/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <CalculatorImpozitAuto />
  );
}
